import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useMemo } from "react";
var Context = /*#__PURE__*/ createContext(null);
export var useApiContext = function() {
    var ctx = useContext(Context);
    if (!ctx) {
        throw new Error("No ApiContext found");
    }
    return ctx;
};
export var ApiProvider = function(props) {
    var value = useMemo(function() {
        return {
            host: props.host,
            token: props.token
        };
    }, [
        props.host,
        props.token
    ]);
    return /*#__PURE__*/ _jsx(Context.Provider, {
        value: value,
        children: props.children
    });
};
